(function () {
  const roots = document.querySelectorAll(
    ".text-message-banner__bubbles[data-animated]",
  );
  if (!roots.length) return;

  for (const root of roots) {
    const wraps = root.querySelectorAll(".text-message-banner__bubble-wrap");
    if (!wraps.length) continue;

    if (!("IntersectionObserver" in window)) {
      for (const wrap of wraps) {
        wrap.classList.add("is-visible");
      }
      continue;
    }

    for (let i = 0; i < wraps.length; i++) {
      const wrap = wraps[i];
      const idx = i;
      const obs = new IntersectionObserver(
        function (entries) {
          if (!entries[0].isIntersecting) return;
          if (wrap.getBoundingClientRect().bottom <= window.innerHeight) {
            wrap.style.transitionDelay = (idx + 1) * 225 + "ms";
            wrap.classList.add("is-visible");
            obs.disconnect();
          }
        },
        { threshold: [0, 0.5, 1.0] },
      );
      obs.observe(wrap);
    }
  }
})();
